import { getUserToken } from '../../../../helpers/authUtils';
import { GetNotifications } from "../";

// As this is a thunk, it is a function which returns a function.
const clearAllNotifications_thunk = (readNotificationsOnly) => {
    return (dispatch, getState) => {
        clearNotifications(dispatch, readNotificationsOnly);        
    };
};

const clearNotifications = (dispatch, readNotificationsOnly) => {
    let url = `/portal/Notifications/ClearNotifications?readOnly=${readNotificationsOnly}`;
    
    let options = {
        ...{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': 'Bearer ' + getUserToken()
            }
        }
    };
    
    fetch(url, options)
        .then(response => {
            if (response.ok) {
                //note expecting non empty body
                return response.json();
            }
            else {
                throw new Error(response);
            }
        })
        .then(data => {
            dispatch(GetNotifications(true));
        })
        .catch(error => {
            dispatch(GetNotifications(true));
        });
};

export default clearAllNotifications_thunk;